import React, { useState,useEffect,useRef,prevState } from "react";
import { formatter, decompressToBase64 } from '../../utils/common.js';
import { format, setDayOfYear } from 'date-fns';
import Modal from 'react-modal';
import { AddReordersToCart, AddToCart, GetCount } from '../ShoppingCart/CartHandler.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faStar } from '@fortawesome/free-regular-svg-icons';
import { faGift, faCog } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import PayLogo from "../CSS/CommonCSS/pay-svgrepo-com.svg"
import SaveLogo from "../CSS/CommonCSS/Save.png"
import { Link, useNavigate } from "react-router-dom";
import "../Portal/AccountInfo.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Dashboard.css"
import Drawer from '@mui/material/Drawer';
import "./invoice.css";
import "./portal.css";
import FullWidthTabs from "./PortalTabs.js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { FormatAlignJustifyTwoTone } from "@mui/icons-material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import "./ItemDetails.css"
import { Box, Button, Grid, TextField } from "@mui/material";


import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


  const source = ["Store", "Web"];

const itemDetailsColumns = [

    {
      id: 1,
      label: 'Order Number',
      minWidth: 150,
      align: 'left',
    },
    {
        id: 2,
      label: 'Request Ship Date',
      minWidth: 150,
      align: 'center',
    },
    {
        id: 3,
      label: 'Item Number',
      minWidth: 120,
      align: 'center',
    },
    {
        id: 4,
      label: 'Item Description',
      minWidth: 300,
      align: 'center',
    },
    {
        id: 5,
      label: 'Site ID',
      minWidth: 70,
      align: 'center',
    },
    {
        id: 6,
      label: 'Price',
      minWidth: 70,
      align: 'center',
    },
    {
      id: 7,
      label: 'Quantity',
      minWidth: 100,
      align: 'right',
    },
    {
        id: 6,
      label: 'Extended Price',
      minWidth: 150,
      align: 'right',
    },
  ];
const orderColumns = [
    { label: 'Transaction #', minWidth: 120 },
    {  label: 'Type', minWidth: 20 },
    {  label: 'Source', minWidth: 20 },
    {
      label: 'Date',
      minWidth: 80,
      align: 'center',
      
    },
    {
      label: 'PO#',
      minWidth: 100,
      align: 'left',
    },
    {
      label: 'Total',
      minWidth: 90,
      align: 'center',
    },
    {
      label: 'Status',
      minWidth: 100,
      align: 'left',
    },
    {
      label: 'Order Now',
      minWidth: 120,
      align: 'left',
    },
  ];
const invoiceColumn = [
    { label: 'Transaction #', minWidth: 120 },
    {  label: 'Type', minWidth: 20 },
    {  label: 'Source', minWidth: 20 },
    {
      label: 'Date',
      minWidth: 80,
      align: 'center',
      
    },
    {
      label: 'PO#',
      minWidth: 100,
      align: 'left',
    },
    {
      label: 'Total',
      minWidth: 90,
      align: 'left',
    },
    {
      label: 'Status',
      minWidth: 100,
      align: 'left',
    },
    {
      label: 'Order Now',
      minWidth: 120,
      align: 'left',
    },
  ];
const all = [
    { label: 'Transaction #', minWidth: 120 },
    {  label: 'Type', minWidth: 20 },
    {  label: 'Source', minWidth: 20 },
    {
      label: 'Date',
      minWidth: 80,
      align: 'center',
      
    },
    {
      label: 'PO#',
      minWidth: 100,
      align: 'left',
    },
    {
      label: 'Total',
      minWidth: 90,
      align: 'left',
    },
    {
      label: 'Status',
      minWidth: 100,
      align: 'left',
    },
    {
      label: 'Order Now',
      minWidth: 120,
      align: 'left',
    },
  ];
//   function createData(name, code, population, size) {
//     const density = population / size;
//     return { name, code, population, size, density };
//   }
//   const rows = [
//     createData('India', 'IN', 1324171354, 3287263),
//     createData('China', 'CN', 1403500365, 9596961),
//     createData('Italy', 'IT', 60483973, 301340),
//     createData('United States', 'US', 327167434, 9833520),
//     createData('Canada', 'CA', 37602103, 9984670),
//     createData('Australia', 'AU', 25475400, 7692024),
//     createData('Germany', 'DE', 83019200, 357578),
//     createData('Ireland', 'IE', 4857000, 70273),
//     createData('Mexico', 'MX', 126577691, 1972550),
//     createData('Japan', 'JP', 126317000, 377973),
//     createData('France', 'FR', 67022000, 640679),
//     createData('United Kingdom', 'GB', 67545757, 242495),
//     createData('Russia', 'RU', 146793744, 17098246),
//     createData('Nigeria', 'NG', 200962417, 923768),
//     createData('Brazil', 'BR', 210147125, 8515767),
//   ];
  
Modal.setAppElement('#root');

const apiUrl = process.env.REACT_APP_BASEURL;

function Portal ({token, setToken, cartCount, setCartCount}) {



const [activeItem, setActiveItem] = useState(null);
const backorderedStyle = () => ({
    fontWeight: "bold",
    color: "red"
});
const [drawerOpen, setDrawerOpen] = React.useState(false);

const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
};
const [balance, setBalance] = useState(0);
const [currentInvoiceData, setCurrentInvoiceData] = useState([]);
const [currentOrderData, setCurrentOrderData] = useState([]);
const [currentQuoteData, setCurrentQuoteData] = useState([]);
const [impData, setImpData] = useState(null);
const [image, setImage] = useState();
const [page, setPage] = React.useState(0);
const [rowsPerPage, setRowsPerPage] = React.useState(10);
const [data, setData] = useState();
const [dashOrder, setDashOrder] = useState(false);
const [dashInvoice, setDashInvoice] = useState(true);
const [logo, setLogo] = useState("");
// const { row } = props;


const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );


const downloadExcelProps = {
    type: 'filtered',
    title: 'test',
    showLabel: true
  }

const GetAllOrders = () => {

    axios.get(apiUrl + "/api/Orders/GetAllOrders", {
        headers: headers
    })
    .then((response) => {
      setCurrentOrderData(response.data); // Make sure response.data is an array
    })
    .catch((error) => {
      console.log(error);
    });
};

function handleImage(e) {
    console.log(e.target.files)
    setImage(e.target.files[0])
}

function submitImage() {
    const formData = new FormData()
    formData.append('image', image)
    axios.post("url", formData)
    .then((res) => {
        // console.log(res)
    })
}
const GetBalance = () => {

    axios.get(apiUrl + "/api/Orders/GetBalance", {
        headers: headers
    })
    .then((response) => {
      setBalance(response.data); // Make sure response.data is an array

    })
    .catch((error) => {
      console.log(error);
    });
};

const getCurrentInvoices =()=> {

    axios.get(apiUrl + "/api/Invoice/GetAllInvoices", {
        headers: headers
    })
    .then((response) => {
      setCurrentInvoiceData(response.data); // Make sure response.data is an array
    })
    .catch((error) => {
      console.log(error);
      setCurrentInvoiceData();
    });
}

const getHistoricInvoices =()=>{

    axios.get(apiUrl + "/api/HistoricInvoice/GetAllHistoricInvoices", {
        headers: headers
    })
    .then((response) => {
      setHistoricInvoiceData(response.data); // Make sure response.data is an array
    })
    .catch((error) => {
      console.log(error);
      setHistoricInvoiceData();
    });
}



function GetAllInvoices () {
    let allInvoices = [];

    if(currentInvoiceData||currentInvoiceData.length!==0)
        {for(let i = 0;i < currentInvoiceData.length;i++){
            allInvoices.push(currentInvoiceData[i])}};

    // console.log("All Invoices after Adding Current Invoice Data: ", allInvoices);

    if(historicInvoiceData||historicInvoiceData.length!==0)
        {for(let i = 0;i < historicInvoiceData.length;i++){
            allInvoices.push(historicInvoiceData[i])}};    

    // console.log("All Invoices after Adding Historic Invoice Data: ", allInvoices);
   
    setAllInvoiceData(allInvoices);
};


const GetLastInvoice = () => {
    if (!allInvoiceData || allInvoiceData.length === 0) {
        console.error("No Invoices Found");
    } else {
        const sortedInvoices = allInvoiceData.sort((a, b) => {
            const dateA = format(Date.parse(a.docdate), "MM/dd/yyyy");
            const dateB = format(Date.parse(b.docdate), "MM/dd/yyyy");

            // Handle invalid dates
            // if (isNaN(dateA) || isNaN(dateB)) {
            //     console.error("Invalid date found in invoices:", a.docdate, b.docdate);
            //     return 0; // Could also return 1 or -1 depending on how you want to handle it
            // }

            return dateB - dateA; // Sort in descending order (most recent first)
        });

        const lastFiveInvoices = sortedInvoices.slice(0, 5);
        setLastInvoice(lastFiveInvoices);
    }
};

const GetLastOrder = () => {
    if (!currentOrderData || currentOrderData.length === 0) {
        console.error("No Orders Found");
    } else {
        const sortedOrders = currentOrderData.sort((a, b) => {
            const dateA = format(Date.parse(a.ordrdate), "MM/dd/yyyy");
            const dateB = format(Date.parse(b.ordrdate), "MM/dd/yyyy");

            // Handle invalid dates
            // if (isNaN(dateA) || isNaN(dateB)) {
            //     console.error("Invalid date found in orders:", a.ordrdate, b.ordrdate);
            //     return 0; // Could also return 1 or -1 depending on how you want to handle it
            // }

            return dateB - dateA; // Sort in descending order (most recent first)
        });

        const lastFiveOrders = sortedOrders.slice(0, 5);
        setLastOrder(lastFiveOrders);
    }
};

//Call the functions to populate fiveLastInvoices and fiveLastOrder


const GetInvoiceItems = (sopnumbe) => {

    // console.log("GetInvoiceItems line 311 sopnumbe:", sopnumbe);
    axios.get(apiUrl + `/api/Orders/GetInvoiceItems?include=${lastOrderInclude}&SOPNumbe=${sopnumbe}`, {
        headers: headers
    })
    .then((response) => {
      // console.log("Invoice Items: ", response.data);
      if(!response.data){alert("Unfortunately, some of the items on this invoice cant be re-ordered online. Call us and we will assist you.");
    }else{
      setInvoiceItems(response.data); // Make sure response.data is an array
    }
    })
    .catch((error) => {
       alert("Unfortunately, some of the items on this invoice cant be re-ordered online. Call us and we will assist you.");
      console.log(error);
    });
};

const GetPastDue = () => {
    axios.get(apiUrl + `/api/Orders/GetPastDue`, {
        headers: headers
    })
    .then((response) => {
      // console.log("Past Due : ", response.data);
      setPastDue(response.data); // Make sure response.data is an array

    })
    .catch((error) => {
      console.log(error);
    });
};

const GetPurchasedItems = () => {

    axios.get(apiUrl + `/api/Orders/GetPurchasedItems?include=${purchasedInclude}`, {
        headers: headers
    })
    .then((response) => {
      setPurchasedItems(response.data); // Make sure response.data is an array

    })
    .catch((error) => {
      console.log(error);
    });
};


const GetAllQuotes = () => {
    axios.get(apiUrl + "/api/Orders/GetAllQuotes", {
        headers: headers
    })
    .then((response) => {
        const data = response.data;

        setCurrentQuoteData(data); // Make sure response.data is an array
      })
    .catch((error) => {
      console.log(error);
    });
};

const GetSopDocument = (soptype,sopnumbe) => {
    // console.log("Here we are in GetSopDocument Line 235:", soptype, sopnumbe);
    axios.get(apiUrl + `/api/Orders/GetSopDocument?sopType=${soptype}&sopNumbe=${sopnumbe}`, {
        headers: headers
    })
    .then((response) => {
      // console.log("SopDocument line 235: ", response.data);
      sopDocument = response.data[0];
    })
    .catch((error) => {
      console.log(error);
    });
};

const getReport = (docnum,name,type) =>{

    let docNum = docnum.trim();
    axios.get(apiUrl + `/api/Orders/einvoicereport?reportName=${name}&invoice=${docNum}&SOPTypeString=${type}`, {
        headers: headers
    })
    .then((response) => {  
      reportOpen(response.data);
    })
    .catch((error) => {
      console.log(error);
    });


}

const[historicInvoiceData, setHistoricInvoiceData] = useState([]);

function reportOpen(report) {
    const reportObject = JSON.parse(report.value);

    if (!reportObject.reportBytes || reportObject.reportBytes.length === 0) {
        alert("Failed to open PDF: Report data is missing or invalid.");
        return;
    }

    // Decode base64 to a byte array
    const byteArray = base64ToArrayBuffer(reportObject.reportBytes);

    // Create a blob from the byte array
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Check if Internet Explorer
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For Internet Explorer
        window.navigator.msSaveOrOpenBlob(blob, "DownloadedOrder.pdf");
    } else {
        // For other browsers
        window.open(url, '_blank');
    }
}

function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const arr = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        arr[i] = binaryString.charCodeAt(i);
    }

    return arr.buffer;
}


const handleClick = (order) =>{
    // console.log(JSON.stringify(order));
    setSelectedOrder(order)
    setIsOpen(true);
}

const headers = ({
    "Accept": "application/json",
    "Content-Type": "application/json",
    'Authorization': 'Bearer ' + token.token
});


const [selectionHeader, setSeletionHeader] = useState("Dashboard")
const [selectionDescription, setSelectionDescription] = useState("")
const [allInvoiceData, setAllInvoiceData] = useState([]);
const [invoiceItems, setInvoiceItems] = useState([]);
const [isModalOpen, setIsModalOpen] = useState(false);
const [isOpen, setIsOpen] = useState(true);
const [lastInvoice, setLastInvoice] = useState([]);
const [lastOrder, setLastOrder] = useState([]);
const [lastInvoiceItems, setLastInvoiceItems] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [invoiceSearch, setInvoiceSearch] = useState('');
const [quoteSearch, setQuoteSearch] = useState('');


const [lastOrderInclude, setLastOrderInclude] = useState("invoice");

const lastOrderIncludeChangeHandler=(e)=>{
    setLastOrderInclude(e.target.value)
}

const mounted = useRef();
const onRequestClose = () => {
    setIsOpen(false);
}

const navigate = useNavigate();

const onRequestModalClose = () => {
    setIsModalOpen(false);

}

const [options, setOptions] = useState({
    // labels: {
        confirmable: "OK",
        cancellable: ""
    // }
});
const [orderList, setOrderList] = useState([]);

const [pastDue, setPastDue] = useState(0);

const pickingStyle = () => ({
    fontWeight: "bold"
});

const [purchasedItems, setPurchasedItems] = useState([]);
const [purchasedInclude, setPurchasedInclude] = useState("invoice");
const purchasedIncludeChangeHandler = (e) =>{
    setPurchasedInclude(e.target.value);
}

const reorderItemClick=(item)=> {   
    setActiveItem(item);
    setIsModalOpen(true);
    //AddToCart(item.itemnmbr, item.unitprce, 1);
    //setCart(GetCart);
}




let sopDocument;

const reOrderItems =(docnum)=>{

   
if(viewInvoices){
    GetSopDocument(3,docnum);
    // console.log("sopDocument in ReOrder Items invoice", sopDocument);
}else if (viewOrders ){
    for(let i = 0;i < currentOrderData.length;i++){
         if(currentOrderData[i].sopnumbe === docnum){sopDocument = currentOrderData[i];
            break;}};
}else if(viewQuotes) {
    for(let i = 0;i < currentQuoteData.length;i++){
         if(currentQuoteData[i].sopnumbe === docnum){sopDocument=currentQuoteData[i];
            break;}};
}else if(lastOrderInclude === "order") {
    for(let i = 0;i < currentOrderData.length;i++){
        if(currentOrderData[i].sopnumbe === docnum){sopDocument = currentOrderData[i];
            break;}};
    
} else if(lastOrderInclude === "invoice") {
    GetSopDocument(3,docnum);
}else{

        GetSopDocument(3,docnum);
        for(let i = 0;i < currentOrderData.length;i++){
            if(currentOrderData[i].sopnumbe === docnum){sopDocument = currentOrderData[i];
               break;}};

}

// console.log("Here you are in reOrderItems before setTimeout",sopDocument)
setTimeout(SopDocumentReturn,250);
}

const SopDocumentReturn = () =>{
    // console.log("Here in SopDocumentReturn SopDocument",sopDocument)
    if(sopDocument){sopDocument.details.map((detail)=>{
        // console.log(`Mustafa this alert: ${detail.itemnmbr} and ${detail.unitprce} and ${detail.quantity}`)
        AddReordersToCart(detail.itemnmbr, detail.unitprce, detail.quantity);
        setCartCount(GetCount());
    }
        
    );} else {
        // console.log("details array is empty!");
    }
}

const reorderOrderClick=()=> {

    if(lastOrderInclude === "invoice" && lastInvoice.docnumbr){   
    GetInvoiceItems(lastInvoice.docnumbr);
    }else if(lastOrderInclude==="invoice" && lastInvoice===null){
        alert("The information you selected was not found. Please try again");
    }else{
        if(lastOrder===null){
            alert("There was no order set on your reorder click. Please try again");
        }else{
        // console.log("reorderOrderClick order line 383", lastOrder);
        lastOrder.details.forEach((detail)=>{
            // console.log("reorderOrderClick order line 385",detail.itemnmbr, detail.unitprce, detail.quantity);
            AddToCart(detail.itemnmbr, detail.unitprce, detail.quantity);
            setCartCount(GetCount());
        });
    }
    }
    //AddToCart(item.itemnmbr, item.unitprce, 1);
    //setCart(GetCart);
}

useEffect(() => {
    axios
        .get(apiUrl + `/api/Header/GetLogo`, {})
        .then((response) => {
            const thisLogo = response.data;
            setLogo(thisLogo.image);
        })
        .catch((error) => {
            console.log(error);
        });
})


const handleItemDetails = (docnum) => {
    let data = null;
    
    if (viewInvoices) {
        data = GetSopDocument(3, docnum); // Assuming this function returns the data directly
        // console.log("sopDocument in ReOrder Items invoice", data);
    } else if (viewOrders) {
        data = currentOrderData.find(order => order.sopnumbe === docnum);
    } else if (viewQuotes) {
        data = currentQuoteData.find(quote => quote.sopnumbe === docnum);
    }

    // console.log("Here you are in reOrderItems before setTimeout", data);
    
    if (data) {
        setImpData(data); // This will trigger a re-render of the component
    } else {
        setImpData(null); // Handle the case where no data is found
    }

    showItemDetails(); // Assuming this function is used to display the details component
}
    

const tableBackHandler = () => {
   if(currentOrderData || impData) {
        currentOrderData.forEach(order => {
            const orderNumber = order.sopnumbe;
               impData.details.forEach(data => {
               const secOrderNumber = data.sopnumbe;
                if(orderNumber===secOrderNumber) {
                    showOrders();
                }
               })
        })
   }
   
   if(currentQuoteData || impData) {
        currentQuoteData.forEach(quote => {
            const quoteNumber = quote.sopnumbe;
               impData.details.forEach(data => {
               const secQuoteNumber = data.sopnumbe;
                if(quoteNumber===secQuoteNumber) {
                    showQuotes();
                }
               })
        })
   }
}
    
    const itemDetails = () => {
        // console.log("Here in itemDetails impData", impData);
    
        const hasData = impData && Array.isArray(impData.details) && impData.details.length > 0;

        return (
            <>
            <div onClick={tableBackHandler}><KeyboardBackspaceIcon sx={{fontSize: 50, padding: 1, color: '#000', marginRight: 10}} /></div>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow >
                                {itemDetailsColumns.map((column) => (
                                    <TableCell
                                       
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth, backgroundColor: '#afaf97' }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {hasData ? (
                                impData.details.map((detail, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <label className="d-trx"><span className="trx-s">{detail.sopnumbe}</span></label>
                                        </TableCell>
                                        <TableCell>
                                            <label className="d-type"><span>{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</span></label>
                                        </TableCell>
                                        <TableCell>
                                            <label className="trx-date"><span className="d-date-s">{detail.itemnmbr}</span></label>
                                        </TableCell>
                                        <TableCell>
                                            <label className="trx-date"><span className="d-date-s">{detail.itemdesc}</span></label>
                                        </TableCell>
                                        <TableCell>
                                            <label className="po"><span>{detail.locncode}</span></label>
                                        </TableCell>
                                        <TableCell>
                                            <label className="trx-total ml-4"><span className="d-total-s">{formatter.format(detail.unitprce)}</span></label>
                                        </TableCell>
                                        <TableCell>
                                            <label className="or-status"><span>{detail.quantity}</span></label>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={itemDetailsColumns.length} align="center">
                                        No data found in the Item Details List!
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            </>
        );
    };
    
    
    

const [selectedOrder, setSelectedOrder] = useState({});





const setStatusFont = (field) => {
    if (field === "Picking ") {
        return (<td style={pickingStyle()}>{field}</td>);
    }
    else if (field === "Backordered") {
        return (<td style={backorderedStyle()}>{field}</td>);
    }
    else if (field == "Shipped") {
        return (<td style={shippedStyle()}>{field}</td>);
    }
    else {
        return (<td>{field}</td>);
    }
};

const shippedStyle = () => ({
    fontWeight: "bold",
    color: "green"
});

const showDashboard = () =>{
    setViewItemDetails(false);
    setAccInfo(false)
    setViewDashboard(true);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(false);
    setSeletionHeader("Customer Dashboard");
    setSelectionDescription("Here is an overview of your account information.");
};

const showItemDetails = () => {
    setAccInfo(false)
    setViewDashboard(false);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(false);
    setViewItemDetails(true);
    setSeletionHeader("Item Detail");
    setSelectionDescription("Your recent activities.");
}

const  showInvoices = () =>{
    setViewItemDetails(false);
    setAccInfo(false)
    setViewDashboard(false);
    setViewInvoices(true);
    setViewOrders(false);
    setViewQuotes(false);
    setSeletionHeader("Invoices");
    setSelectionDescription("A list of all invoices associated with this account.");
};

const  showOrders = () =>{
    setViewItemDetails(false);
    setAccInfo(false)
    setViewDashboard(false);
    setViewInvoices(false);
    setViewQuotes(false);
    setViewOrders(true);
    setSeletionHeader("Open Orders");
    setSelectionDescription("A list of completed orders purchased under this account");
};


const  showQuotes = () =>{
    setViewItemDetails(false);
    setViewDashboard(false);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(true);
    setAccInfo(false)
    setSeletionHeader("Portal");
    setSelectionDescription("A list of quotes offered to this account");
};

const signOut = () =>{
    sessionStorage.removeItem('token');
    setToken();
    // window.location.reload(true);
    
}

const showAccountInfo = () =>{
    setViewItemDetails(false);
    setViewDashboard(false);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(false);
    setAccInfo(true);
    setSeletionHeader("Account Information");
    setSelectionDescription("Here is an overview of your account information!");
}

const [sortDirection, setSortDirection] = useState(null);
const [viewDashboard, setViewDashboard] = useState (true);
const [viewInvoices, setViewInvoices] = useState (false);
const [viewOrders, setViewOrders] = useState (false);
const [viewQuotes, setViewQuotes] = useState (false);
const [accInfo, setAccInfo] = useState (false);
const [viewItemDetails, setViewItemDetails] = useState (false);


useEffect(() => {
if(!mounted.current){
getCurrentInvoices();
getHistoricInvoices();
GetBalance();
showDashboard();
// GetCart();
// GetLastInvoiceItems();
GetPurchasedItems();
GetPastDue();
GetAllOrders();
GetAllQuotes();
}

}, []);

useEffect(()=>{
    GetAllInvoices();
    GetLastInvoice();
},[currentInvoiceData, historicInvoiceData])

useEffect(()=>{
    GetLastOrder();
},[currentOrderData])

useEffect(()=>{
    GetLastInvoice();
},[allInvoiceData])



const dashboardOpen = () => {
    return(
        <div className="d-body ">

        <div className="dashboard">
            <div className="part-1 lg:flex lg:justify-between">
                <div>
                <h3 className="lg:mt-[0.5rem] lg:ml-[1rem] dash-txt">DASHBOARD</h3>
                <div className="dash-user-name lg:mt-[2rem]">
                {token.firstName}
                            <span className="sp-all">{token.lastName}</span>
                </div>
                <div className="pa-wrapper">
                <div className="tronic">Key Tronic Corporation</div>
                <div className="d-address">
                         HQ 4424 N Sullivan Rd.
                        <span>Spokane Valley, WA 99216</span>
                </div>
                <div className="c-acc-txt"> Customer Account:
                 <span className="sp-all">100586</span></div>
                </div>
                </div>
                <div className=" lg:my-[6rem] st-wrapper">
                    <div className="lg:ml-[1rem]">ACCOUNT STATUS</div>
                    <div className="d-acc-status">

                    <div className=" lg:mr-[1rem] mr-[1rem]">
                    <div className="">
                        Balance: <span className="d-balance">{formatter.format(balance)}</span>
                    </div>
                    <div className="">
                    Past Due: <span className="d-due">{formatter.format(pastDue)}</span>
                    </div>
                    <div className="">
                        Point Balance: <span className="d-point">{"2333"}</span>
                    </div>
                    </div>
                    <div>
                        <div>Last Purchase: <span className="font-bold lg:ml-12">4/12/2027</span></div>
                        <div>Last Purchase Amount: <span className="font-bold lg:ml-6">$9.98</span></div>
                    </div>
                    </div>
                    
                </div>
                
               <div>
                <img
                     className="d-profile  "
                     src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                     alt="profile"
                    />
               </div>
               <img
                                            className="lg:mt-[1rem] lg:mr-[10rem] lg:w-[10rem] lg:h-[5rem] dash-logo "
                                            src={"data:image/png;base64, " + logo}
                                            alt="WaitingForLogo"
                                        />
                </div>
        
             
            <div className="part-2 lg:flex justify-between ">
                <p className="d-repo lg:flex lg:ml-[1rem]">
                   Account Rep: <span className="sp-all">PAUL WILKERSON</span>
                </p>
            </div>
            <div className="part-3 lg:pt-8">
                <div className="flex">
                <div className="lg:text-2xl font-bold lg:ml-[42rem] lg:pb-[2rem] rec-activity">
                    Recent Activity
                </div>
                <div className="dropdown-1"> <span >Include: </span>
                                <select onChange={(e) => lastOrderIncludeChangeHandler(e)} value={lastOrderInclude} className="d-options">
                                    <option value="invoice">Invoices</option>
                                    <option value="order">Orders</option>
                                    <option value="both">All</option>
                                </select>
                </div> 
                </div>
                <div className="last-trans lg:flex lg:ml-[1rem] lg:flex-col">
                  <div className="dash-table lg:w-[70rem] lg:ml-[10rem]">{renderLastTransaction()}</div>
                  <div className="lg:flex lg:ml-[30rem] lg:mt-[2rem]">

                  </div>
                            
                </div>
            </div>
            <hr className="hr1"/>
            <div className="part-4 lg:flex pt-10">
                        <h6 className="font-bold preferences">Preferences</h6>
                    <div className="lg:flex lg:w-[60rem]">
                        <div className="text-4">Shipping Method:<span className="st-1">Ground</span></div>
                        <div className="text-4">Tax Schedule:<span className="st-2">State Tax USA</span></div>
                        <div className="text-4">Tax Exempt#:<span className="st-3">13451345-5</span></div>
                        <div className="text-4">Payment Method:<span className="st-4">AMEX</span></div>
                    </div>
                    <div className=" lg:ml-[24rem] lg:ml-8 lg:lg:pt-3 since">
                        Customer since {format(Date.parse(token.customerSince), "MM/dd/yyyy")}
                    </div>
            </div>
            <hr className="hr2"/>
            
        </div>
        </div>
      );
}


const accountInfoOpen = () => {
    return(
        <>
          <Grid container spacing={6}  className="main-con" sx={{overflow: "hidden"}}>
            <Paper  sx={{width: "100%", height: "100vh",}} className="" >
          <Grid container spacing={2} className=""> 
                <Paper sx={{width: "100%", height: "11rem", paddingTop: 4, }} className="lg:flex acc-header">
                    <Grid item xs={10} className="">
                         <h1 className="acc-title">Account Information</h1>
                         <div className="acc-des flex-col"><span>Below are options for customizing your</span> 
                                <span>account profile. Your name, login credentials,</span> 
                                <span>security options are set by administrator.</span>
                         </div>
                    </Grid>
                    <Grid xs={2} >
                        <div className="acc-profile " ><img
                                                    className="h-8 w-8 rounded-full lg:w-[6rem] lg:h-[6rem]"
                                                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                                    alt="profile"
                                                /></div>
                    </Grid>
                </Paper>

          </Grid>
          <Grid container spacing={2} sx={{marginTop: 2}}>
            <Paper elevation={0} sx={{width: "100%",}} className="lg:pt-[1rem] lg:pl-[12rem] lg:h-[4rem] se-grd lg:flex">
                <Grid item xs={4} >
                  <h2 className="acc-contact ">Contact Name Info</h2>
                </Grid>
                <Grid item xs={5}>
                  <div className="acc-name">Name:   Micheal Hollingsworth</div>
                </Grid>
                <Grid item xs={5}>
                  <div className="acc-login">Login:  mhollingsworth@cdmsoftware.com</div>
                </Grid>
            </Paper>
          </Grid>
          <Grid container spacing={2} sx={{}}>
            <Paper elevation={0}  sx={{width: "100%",}} className="lg:h-[4rem] lg:pt-1rem lg:pl-[12rem] flex th-grd">
                <Grid item xs={4} >
                <label className="acc-label">Profile Picture</label>
                </Grid>
                <Grid item xs={3}>
                <div className="lg:text-sm add-txt">Add a profile picture to personalize your account</div>
                </Grid>
                <Grid item xs={5}>
                <div className="acc-img2"><img className="accInfo-prof" src=" " alt=" "/>       
                    <div><input type="file" name="file" onChange={handleImage}/> </div>
                    <div className="pic-sub" onClick={submitImage}>Submit</div>
                </div>                </Grid>
            </Paper>
          </Grid>
          <Grid spacing={2} sx={{}} className="lg:mt-[3rem] flex f-inp">
                <Grid item xs={4} sx={{}} >
                    <label className="lg:ml-[11rem]">Display Name</label>
                </Grid>
                <Grid item xs={8} className="">
                    <input type="text" className=" dash-input lg:w-[40rem]  lg:h-10"/>
                </Grid>
          </Grid>
          <Grid spacing={2} sx={{}} className="lg:mt-[2rem] flex f-inp">
                <Grid item xs={4} sx={{}} >
                    <label className="lg:ml-[11rem]">Title</label>
                </Grid>
                <Grid item xs={8} className="">
                    <input type="text" className=" dash-input lg:w-[40rem]  lg:h-10 "/>
                </Grid>
          </Grid>
          <Grid spacing={2} sx={{}} className="lg:mt-[2rem] f-inp flex">
                <Grid item xs={4} sx={{}} >
                    <label className="lg:ml-[11rem]">Recovery Email</label>
                </Grid>
                <Grid item xs={8} className="">
                    <input type="text" className=" dash-input lg:w-[40rem]  lg:h-10"/>
                </Grid>
          </Grid>
          <Grid spacing={2} sx={{}} className="lg:mt-[2rem] f-inp flex">
                <Grid item xs={4} sx={{}} >
                    <label className="lg:ml-[11rem]">Phone Recovery</label>
                </Grid>
                <Grid item xs={3} className="">
                    <input type="text" className=" dash-input lg:w-[20rem]  lg:h-10"/>
                </Grid>
                <Grid item xs={1} sx={{}}>
                    <label className="bd-label">Birthday</label>
                </Grid>
                <Grid item xs={4} className="bd-date">
                    <input type="date" className="  border "/>
                </Grid>
          </Grid>
          <Grid spacing={2} sx={{}} className="lg:mt-[2rem] f-inp flex">
                <Grid item xs={4} sx={{}} >
                 <label className="lg:ml-[11rem]">Communication Preferences</label>
                </Grid>
                <Grid item xs={8} >
                <select className="s-txt">
                    <option value="email-text">Email & Text</option>
                    <option value=" ">NUN & Nun</option>
                    <option value=" ">NUN & NUN</option>
                    <option value=" ">NUN & NUN</option>
                </select>
                </Grid>
          </Grid>
            </Paper>
          </Grid>  
        </>
    )
}

<div className="accInfo-container">
<div className="row1 lg:flex lg:px-8" >
    <div className="acc-title-des">
        <h1 className="acc-title">Account Information</h1>
        <div className="acc-des flex-col"><span>Below are options for customizing your</span> 
                                <span>account profile. Your name, login credentials,</span> 
                                <span>security options are set by administrator.</span>
                                </div>
    </div>
    <div className="acc-img1 lg:relative lg:left-[70rem] "><img id="top-img" src="" alt="image"/></div>
</div> 
<hr/>

<div className="row2">
    <h2 className="acc-contact">Contact Name Info</h2>
    <div className="acc-name">Name:   Micheal Hollingsworth</div>
    <div className="acc-login">Login:  mhollingsworth@cdmsoftware.com</div>
</div>
<div className="row3"> 
<label className="acc-label">Profile Picture</label>
<div className="acc-pro-text">Add a profile picture to personalize your account</div>
<div className="acc-img2"><img className="accInfo-prof" src=" " alt=" "/>       
    <div><input type="file" name="file" onChange={handleImage}/> </div>
    <div className="pic-sub" onClick={submitImage}>Submit</div>
</div>
</div>
<div className="row4">
    <label className="acc-label">Display Name</label>
    <input 
     className="acc-input"
     type="text" 
     id="display name"
    //  onChange={" "}
    />
</div>
<div className="row5">
    <label className="acc-label">Title</label>
    <input 
     className="acc-input-title"
     type="text" 
     id="display name"
    //  onChange={" "}
    />
</div>
<div className="row6">
    <label className="acc-label">Recovery Email</label>
    <input 
     className="acc-input2"
     type="text" 
     id="display name"
    //  onChange={" "}
    />
</div>
<div className="row7">
    <label className="label-phone">Recovery Phone</label>
    <input 
     className="input-phone"
     type="text" 
     id="display name"
    //  onChange={" "}
    />
    <div className="les">
    <p id="label-bd ">Birthday</p>
    <input type="date" className="input-bd"></input>
    </div>
</div>
<div className="row8">
    <label className="communication ">Communication Preferences</label>
    <select id="com-drop">
        <option value="email-text">Email & Text</option>
        <option value=" ">NUN & Nun</option>
        <option value=" ">NUN & NUN</option>
        <option value=" ">NUN & NUN</option>
    </select>
</div>
</div>



const invoiceSearchHandler = (event) => {
    setInvoiceSearch(event.target.value.toUpperCase());
  };

  const invoiceFiltered = currentInvoiceData.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toUpperCase().includes(invoiceSearch)
    )
  );


const invoicesOpen = () => {

    // const columns = [
        
    //     {header: 'Invoice Number',key: 'docnumbr',td: (data) => <div className = 'bold'  >{data.docnumbr}</div>},
    //     {header: 'Invoice Date',key: 'docdate', td: (data) => <div>{format(Date.parse(data.docdate), "MM/dd/yyyy")}</div>},
    //     {header: 'Due Date',key: 'dueDate', td: (data) => <div>{format(Date.parse(data.dueDate), "MM/dd/yyyy")}</div>},
    //     {header: 'Payment Terms',key: 'pymtrmid',},
    //     {header: 'Subtotal',key: 'subtotal',td: (data) => <div>{formatter.format(data.subtotal)}</div>},
    //     {header: 'Freight', key: 'frtamnt',td: (data) => <div>{formatter.format(data.frtamnt)}</div>},          
    //     {header: 'Tax',key: 'taxamnt',td: (data) => <div>{formatter.format(data.taxamnt)}</div>},
    //     {header: 'Invoice Amount',key: 'ortrxamt',td: (data) => <div>{formatter.format(data.ortrxamt)}</div>},
    //     {header: 'Balance Due',key: 'curtrxam',td: (data) => {if(Date.parse(data.dueDate) < Date.now() && data.curtrxam > 0){
    //                                                                 return(<div className = 'bold-red'>{formatter.format(data.curtrxam)}</div>)} 
    //                                                             else if(data.curtrxam > 0){
    //                                                                 return(<div className = 'bold'>{formatter.format(data.curtrxam)}</div>)}
    //                                                             else{
    //                                                                 return(<div>{formatter.format(data.curtrxam)}</div>)}}},
    //     {header: 'Order Now', td: (data) => <div className = 'flex-col' onClick={() => reOrderItems(data.docnumbr)}>REORDER</div>},  
    //     {header: 'Actions',
    //     td: (data) => {
    //       if (data.curtrxam > 0.01) {
    //       return (
    //         <div className = 'flex-row'>
    //           <div className = 'flex-col'>
    //           <img
    //             src={SaveLogo}
    //             width='30'
    //             height='30'
    //             onClick={() => getReport(data.docnumbr, "Invoice_Posted","PostedInvoice")}
    //           />
    //           </div>
    //           <div className = 'flex-col'>
    //           <a href="https://primepowerserv.securepayments.cardpointe.com/pay?"
    //             target="_blank"
    //             rel="noreferrer noopener">
    //           <img
    //             src={PayLogo}
    //             width='30'
    //             height='30'
    //           /></a>
    //           </div>
    //         </div>
    //       )}else{
    //           return (
    //               <div className = 'flex-row'>
    //                 <div className = 'flex-col'>
    //                 <img
    //                   src={SaveLogo}
    //                   width='30'
    //                   height='30'
    //                   onClick={() => getReport(data.docnumbr,"Invoice_Posted","PostedInvoice")}
    //                 />
    //                 </div>
    //               </div>)
    //       }
    //     }
    //     }
    // ];
    // if(viewInvoices){
    // if(!allInvoiceData){
    //     return <h2>Awaiting Invoice Data.... If this is more than 5 seconds, you may not have any open invoices</h2>;}else{
    //         return<ReactFlexyTable  data={allInvoiceData} columns = {columns}
    //         sortable filterable showExcelButton downloadExcelProps={downloadExcelProps}></ReactFlexyTable>;
    //     }
    // }

    return(
        <>
        <TextField
        label="Search for invoice number.."
        variant="outlined"
        value={invoiceSearch}
        onChange={invoiceSearchHandler}
        fullWidth
        margin="normal"
      />
        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none', maxHeight: 630 }}>
        <Table   aria-label="collapsible table" sx={{ border: 'none',  }}>
          <TableHead sx={{backgroundColor: "#cccccc"}}>
            <TableRow>
              <TableCell />
              <TableCell>Invoice Number</TableCell>
              <TableCell align="right">Invoice Date</TableCell>
              <TableCell align="right">Payment Terms</TableCell>
              <TableCell align="right">Subtotal</TableCell>
              <TableCell align="right">Due Date</TableCell>
              <TableCell align="right">Freight</TableCell>
              <TableCell align="right">Tax</TableCell>
              <TableCell align="right">Invoice Amount</TableCell>
              <TableCell align="right">Balance Due</TableCell>
              <TableCell align="right">Order Now</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {invoiceFiltered.map((invoice, index) => (
                    <InvoiceRow key={index} invoice={invoice}
                         childColumn={itemDetailsColumns}
                         reOrderItems={reOrderItems}
                         getReport={getReport}
                          />
                  ))}
        
          </TableBody>
        </Table>
        </TableContainer>
        </>
        
        )
};

const orderSearchHandler = (event) => {
    setSearchTerm(event.target.value.toUpperCase());
  };

  const orderFiltered = currentOrderData.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toUpperCase().includes(searchTerm)
    )
  );

const ordersOpen = () => {
   
//        const columns = [
//         {header: 'Order Number',key: 'sopnumbe',td: (data) => <div className = 'bold' onClick={() => handleItemDetails(data.sopnumbe)}>{data.sopnumbe}</div>},
//         {header: 'Order Date',key: 'ordrdate', td: (data) => <div>{format(Date.parse(data.ordrdate), "MM/dd/yyyy")}</div>},
//         {header: 'Origin',key: 'origin',},
//         {header: "Site ID", key: "locncode", td: (data) => <div>{data.locncode}</div>},
//         {header: 'Due Date',key: 'duedate', td: (data) => <div>{format(Date.parse(data.duedate), "MM/dd/yyyy")}</div>},
//         {header: 'Order Amount',key: 'docamnt',td: (data) => <div>{formatter.format(data.docamnt)}</div>},
//         {header: 'Name', key: 'custname'},          
//         {header: 'Order Status',key: 'status'},
//         {header: 'Order Now', td: (data) => <div className = 'flex-col' onClick={() => reOrderItems(data.sopnumbe)}>REORDER</div>},  
//         {header: 'Actions', td: (data) => <div className = 'flex-col'><img src={SaveLogo} width='30' height='30' 
//         onClick={() => getReport(data.sopnumbe,"Order","Order")}/></div>}
//     ];
// if(viewOrders){    
// if(!currentOrderData){
//     return <h2>Awaiting Order Data.... If this is more than 5 seconds, you may not have any open orders</h2>;}else{
//         return <ReactFlexyTable  data={currentOrderData} columns = {columns} 
//             sortable filterable showExcelButton downloadExcelProps={downloadExcelProps}></ReactFlexyTable>;
//     }
// }



return(
<>
<TextField
        label="Search for order number.."
        variant="outlined"
        value={searchTerm}
        onChange={orderSearchHandler}
        fullWidth
        margin="normal"
      />
<TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none', maxHeight: 630 }}>
<Table id="myTable"  aria-label="collapsible table" sx={{ border: 'none',  }}>
  <TableHead sx={{backgroundColor: "#cccccc"}}>
    <TableRow>
      <TableCell />
      <TableCell>Order Number</TableCell>
      <TableCell align="right">Order Date</TableCell>
      <TableCell align="right">Origin</TableCell>
      <TableCell align="right">Site ID</TableCell>
      <TableCell align="right">Due Date</TableCell>
      <TableCell align="right">Order Amount</TableCell>
      <TableCell align="right">Name</TableCell>
      <TableCell align="right">Order Status</TableCell>
      <TableCell align="right">Order Now</TableCell>
      <TableCell align="right">Actions</TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
  {orderFiltered.map((order, index) => (
            <OrderRow key={index} order={order}
                 childColumn={itemDetailsColumns}
                 reOrderItems={reOrderItems}
                 getReport={getReport}
                  />
          ))}

  </TableBody>
</Table>
</TableContainer>
</>

)
};


const quoteSearchHandler = (event) => {
    setQuoteSearch(event.target.value.toUpperCase());
  };

  const quoteFiltered = currentQuoteData.filter((row) =>
    Object.values(row).some((val) =>
      String(val).toUpperCase().includes(quoteSearch)
    )
  );

const quotesOpen = () => {
    
//     const columns = [
//         {header: 'Quote Number',key: 'sopnumbe',td: (data) => <div className = 'bold' onClick={() => handleItemDetails(data.sopnumbe)}>{data.sopnumbe}</div>},
//         {header: 'Quote Date',key: 'quotedat', td: (data) => <div>{format(Date.parse(data.quotedat), "MM/dd/yyyy")}</div>},
//         {header: 'Quote Amount',key: 'docamnt',td: (data) => <div>{formatter.format(data.docamnt)}</div>},
//         {header: 'Name', key: 'custname'},
//         {header: 'Order Now', td: (data) => <div className = 'flex-col' onClick={() => reOrderItems(data.sopnumbe)}>Order Now</div>},          
//         {header: 'Actions', td: (data) => <div className = 'flex-col'><img src={SaveLogo} width='30' height='30' 
//         onClick={() => getReport(data.sopnumbe, "Quote" ,"Quote")}/></div>}
//     ];
// if(viewQuotes) {
//     if(!currentQuoteData){
//         return <h2>Awaiting Order Data.... If this is more than 5 seconds, you may not have any open orders</h2>;}else{
//             return <ReactFlexyTable  data={currentQuoteData} columns = {columns}
//                 sortable filterable showExcelButton downloadExcelProps={downloadExcelProps}></ReactFlexyTable>;
//         }
// }

return(
    <>
    <TextField
        label="Search for quote number.."
        variant="outlined"
        value={quoteSearch}
        onChange={quoteSearchHandler}
        fullWidth
        margin="normal"
      />
    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none', maxHeight: 630 }}>
    <Table   aria-label="collapsible table" sx={{ border: 'none',  }}>
      <TableHead sx={{backgroundColor: "#cccccc"}}>
        <TableRow>
          <TableCell />
          <TableCell>Quote Number</TableCell>
          <TableCell align="right">Quote Date</TableCell>
          <TableCell align="right">Quote Amount</TableCell>
          <TableCell align="right">Name</TableCell>
          <TableCell align="right">Order Now</TableCell>
          <TableCell align="center">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
      {quoteFiltered.map((quote, index) => (
                <QuoteRow key={index} quote={quote}
                     childColumn={itemDetailsColumns}
                     reOrderItems={reOrderItems}
                     getReport={getReport}
                />
              ))}
    
      </TableBody>
    </Table>
    </TableContainer>
    </>
    
    )


};

const renderLastTransaction = () => {
    
        if (lastOrderInclude === 'order') {
            return (
                <Paper sx={{ width: '100%', overflow: 'hidden', }}>
                    <TableContainer sx={{ maxHeight: 440, }}>
                    <Table stickyHeader aria-label="sticky table" sx={{ border: 'none', boxShadow: 'none'}}>
                        <TableHead>
                            <TableRow>
                            {orderColumns.map((column) => (
                                <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                                >
                                {column.label}
                                </TableCell>
                            ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lastOrder
                            .map((recentOrder, index) => {
                                return (
                                <TableRow >
                                <TableCell key={index}>
                                <label className="d-trx"><span className="trx-s">{recentOrder ? recentOrder.sopnumbe : "None"}</span></label>
                                </TableCell>
                                <TableCell key={index}>
                                <label className="d-type"><span>order</span></label>
                                </TableCell>
                                <TableCell key={index}>
                                <label className="d-type"><span>Web</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="trx-date"><span className="d-date-s">{recentOrder ? format(Date.parse(recentOrder.ordrdate), "MM/dd/yyyy") : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="po"><span>4455</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="trx-total ml-4"><span className="d-total-s">{recentOrder ? formatter.format(recentOrder.docamnt) : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="or-status"><div className="flex-row"><di>{recentOrder.status}</di><div><Link to="https://www.ups.com/track?loc=en_US&msockid=1192a50f7dda65080390b1ad7cb5645e&requester=ST/" ><span>(Track)</span></Link></div></div></label>     
                                 </TableCell>
                                <TableCell>
                                <Button 
                                    sx={{fontSize: 13, height: 23}}
                                    variant="contained" 
                                    color="primary" 
                                    onClick={() => reOrderItems(recentOrder.sopnumbe)}
                                >
                                    REORDER
                                </Button>     
                                 </TableCell>
                                </TableRow>
                                );
                            })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    {/* <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                    </Paper>
               
            );
        } else if(lastOrderInclude === "invoice") {
            return (
                <div className="dash-table">
                <Paper sx={{ width: '100%', overflow: 'hidden', background: ""}}>
                    <TableContainer sx={{ maxHeight: 440, }}>
                        <Table stickyHeader aria-label="sticky table" sx={{ border: 'none', boxShadow: 'none'}}>
                        <TableHead>
                            <TableRow>
                            {invoiceColumn.map((column) => (
                                <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                                >
                                {column.label}
                                </TableCell>
                            ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lastInvoice
                            .map((recentInvoice, index) => {
                                return (
                                <TableRow key={index} >
                                <TableCell >
                                     <label className="d-trx "><span className="trx-s">{!!recentInvoice ? recentInvoice.docnumbr : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                    <label className="d-type "><span>Invoice</span></label>
                                </TableCell>
                                <TableCell>
                                    <label className="d-type "><span>{source[0]}</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="trx-date ml-[1rem] "><span className="d-date-s">{!!recentInvoice ? format(Date.parse(recentInvoice.docdate), "MM/dd/yyyy") : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="po"><span>4455</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="trx-total  "><span className="d-total-s">{!!recentInvoice ? formatter.format(recentInvoice.ortrxamt) : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="or-status"><div className="flex-row"><di>{recentInvoice.status}</di><div><Link to="https://www.ups.com/track?loc=en_US&msockid=1192a50f7dda65080390b1ad7cb5645e&requester=ST/" ><span>(Track)</span></Link></div></div></label>
                                </TableCell>
                                <TableCell>
                                <Button 
                                    sx={{fontSize: 13, height: 23}}
                                    variant="contained" 
                                    color="primary" 
                                    onClick={() => reOrderItems(recentInvoice.docnumbr)}
                                >
                                    REORDER
                                </Button>
                                </TableCell>
                                </TableRow>
                                );
                            })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    {/* <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                    </Paper>
                </div>
            );
        } else {
            return (
                <div className="dash-table">
                <Paper sx={{ width: '100%', overflow: 'hidden', background: ""}}>
                    <TableContainer sx={{ maxHeight: 440, }}>
                        <Table stickyHeader aria-label="sticky table" sx={{ border: 'none', boxShadow: 'none'}}>
                        <TableHead>
                            <TableRow>
                            {all.map((column) => (
                                <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                                >
                                {column.label}
                                </TableCell>
                            ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lastInvoice
                            .map((item, index) => {
                                return (
                                <TableRow key={index} >
                                <TableCell >
                                     <label className="d-trx "><span className="trx-s">{!!item ? item.docnumbr : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                    <label className="d-type "><span>Invoice</span></label>
                                </TableCell>
                                <TableCell>
                                    <label className="d-type "><span>{source[0]}</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="trx-date ml-[1rem] "><span className="d-date-s">{!!item ? format(Date.parse(item.docdate), "MM/dd/yyyy") : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="po"><span>4455</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="trx-total  "><span className="d-total-s">{!!item ? formatter.format(item.ortrxamt) : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                     <label className="or-status"><div className="flex-row"><di>{item.status}</di><div><Link to="https://www.ups.com/track?loc=en_US&msockid=1192a50f7dda65080390b1ad7cb5645e&requester=ST/" ><span>(Track)</span></Link></div></div></label>
                                </TableCell>
                                <TableCell>
                                <Button 
                                    sx={{fontSize: 13, height: 23}}
                                    variant="contained" 
                                    color="primary" 
                                    onClick={() => reOrderItems(item.docnumbr)}
                                >
                                    REORDER
                                </Button>
                                </TableCell>
                                </TableRow>
                                );
                            })}
                            {lastOrder
                            .map((data, index) => {
                                return (
                                <TableRow key={index}>
                                <TableCell key={index}>
                                <label className="d-trx"><span className="trx-s">{data ? data.sopnumbe : "None"}</span></label>
                                </TableCell>
                                <TableCell key={index}>
                                <label className="d-type"><span>order</span></label>
                                </TableCell>
                                <TableCell key={index}>
                                <label className="d-type"><span>{source[1]}</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="trx-date"><span className="d-date-s">{data ? format(Date.parse(data.ordrdate), "MM/dd/yyyy") : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="po"><span>4455</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="trx-total ml-4"><span className="d-total-s">{data ? formatter.format(data.docamnt) : "None"}</span></label>
                                </TableCell>
                                <TableCell>
                                <label className="or-status"><div className="flex-row"><di>{data.status}</di><div><Link to="https://www.ups.com/track?loc=en_US&msockid=1192a50f7dda65080390b1ad7cb5645e&requester=ST/" ><span>(Track)</span></Link></div></div></label>        
                                </TableCell>
                                <TableCell>
                                <Button 
                                    sx={{fontSize: 13, height: 23}}
                                    variant="contained" 
                                    color="primary" 
                                    onClick={() => reOrderItems(data.sopnumbe)}
                                >
                                    REORDER
                                </Button>     
                                 </TableCell>
                                </TableRow>
                                );
                            })}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    {/* <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                    </Paper>
                </div>
            );
        }
    
}




    const dataSelection = () =>{
        return(
        <div className='portal-cover'>
            <div className="invoice">
               {viewInvoices && invoicesOpen()}
            </div>
            {viewOrders && ordersOpen()}
            {viewQuotes && quotesOpen()}
            {viewDashboard && dashboardOpen()}
            {accInfo && accountInfoOpen()}
            {viewItemDetails && itemDetails()}
        </div>);
    }

    const DrawerList = (
        <div className = 'container portal-con pt-3' id=" ">
        <h3 className="greeting"> Welcome {token.customerName}!</h3>
        <h3 className="cust-dash"><FontAwesomeIcon icon={faUser} className="fa-fw" />{selectionHeader}</h3>
        <h6 className="l-des">{selectionDescription}</h6>
    
        <div className="">
            <div onClick={toggleDrawer(false)} className="flex-col  " style={{ marginLeft: "10px" }}>
                <hr />
                <p><div className="portal-items" role="menuitem" onClick={showDashboard}>Dashboard</div></p>
                <p><div className="portal-items" role="menuitem" onClick={showInvoices}>Invoices</div></p>
                <p><div className="portal-items" role="menuitem" onClick={showOrders}>Orders</div></p>
                <p><div className="portal-items" role="menuitem" onClick={showQuotes}>Quotes</div></p>
                <p className="portal-items"><a >Payment Methods</a></p>
                <p className="portal-items"><a>Lists</a></p>
                <p><div className="portal-items" role="menuitem" onClick={signOut}>Sign-Out</div></p>
                <br />
                <h5><FontAwesomeIcon icon={faGift} className="fa-fw" />Rewards</h5>
                <hr />
                <p className="portal-items"><a>Overview</a></p>
                <p className="portal-items"><a>Super Rewards</a></p>
                <br />
                <h5><FontAwesomeIcon icon={faStar} className="fa-fw" />My Activity</h5>
                <hr />
                <p className="portal-items"><a>My Page</a></p>
                <br />
                <h5><FontAwesomeIcon icon={faCog} className="fa-fw" />Settings</h5>
                <hr />
                <p><div className="portal-items" role="menuitem" onClick={showAccountInfo}>Account Information</div></p>
                <p className="portal-items"><a>Communication Preferences</a></p>
            </div>
            

        </div> 
    </div>
      );

      
    return (
        // <div id="bootstrap-overrides">
        <>
            <div className="portal-header mt-3 lg:h-[4rem] flex">
                <div className="mobile-tabs flex">
                <p className="mo-drawer" onClick={toggleDrawer(true)}> <ArrowBackIcon className='mo-icon'/> Portal</p>
                <p className="inv-text" onClick={showInvoices}>Invoices</p>
                <p className="ord-text" onClick={showOrders}>Orders</p>
                <p className="quo-text" onClick={showQuotes}>Quotes</p>
                </div>
                    <FullWidthTabs
                     toggleDrawer={toggleDrawer(true)}
                     showInvoices={showInvoices}
                     showDashboard={showDashboard}
                     showOrders={showOrders}
                     showQuotes={showQuotes}
                     showAccountInfo={showAccountInfo}

                      />
                    <Drawer open={drawerOpen} onClose={toggleDrawer(false)}>
                        {DrawerList}
                    </Drawer>
            </div>
                <div className="m-tabs-cover ">
                            {dataSelection()}
                </div>
        </>
    
           
    );
}

export default Portal;



  

  function OrderRow(props) {
    const { order, childColumn, reOrderItems, getReport } = props;
    const [open, setOpen, ] = React.useState(false);
  
    return (
      <React.Fragment >
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowDownIcon /> : <AddIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
          {order.sopnumbe}
          </TableCell>
          <TableCell align="right">{format(Date.parse(order.ordrdate), "MM/dd/yyyy")}</TableCell>
          <TableCell align="right">{order.origin}</TableCell>
          <TableCell align="right">{order.locncode}</TableCell>
          <TableCell align="right">{format(Date.parse(order.duedate), "MM/dd/yyyy")}</TableCell>
          <TableCell align="right">{formatter.format(order.docamnt)}</TableCell>
          <TableCell align="right">{order.custname}</TableCell>
          <TableCell align="right">{order.status}</TableCell>
          <TableCell align="right" onClick={() => reOrderItems(order.sopnumbe)} className="cursor-pointer">REORDER</TableCell>
          <TableCell align="right" className="cursor-pointer"><img src={SaveLogo} width='30' height='30' 
                     onClick={() => getReport(order.sopnumbe,"Order","Order")}/></TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Details
                </Typography>
                <Table size="small" aria-label="purchases"  sx={{ border: 'none', boxShadow: 'none' , marginLeft: 10}}>
                  <TableHead>
                  <TableRow >
                                {childColumn.map((column) => (
                                    <TableCell
                                       
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                  </TableHead>
                  <TableBody>
                    {order.details.map((detail) => (
                      <TableRow key={detail.sopnumbe}>
                        <TableCell component="th" scope="row">
                          {detail.sopnumbe}
                        </TableCell>
                        <TableCell align="right">{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</TableCell>
                        <TableCell align="right">{detail.itemnmbr}</TableCell>
                        <TableCell align="right">
                          {detail.itemdesc}
                        </TableCell>
                        <TableCell align="right">{detail.locncode}</TableCell>
                        <TableCell align="right">{formatter.format(detail.unitprce)}</TableCell>
                        <TableCell align="right">{detail.quantity}</TableCell>
                        <TableCell align="right">{formatter.format(detail.xtndprce)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }



  function InvoiceRow(props) {
    const { invoice, childColumn, reOrderItems, getReport } = props;
    const [open, setOpen, ] = React.useState(false);
  
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowDownIcon /> : <AddIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
          {invoice.docnumbr}
          </TableCell>
          <TableCell align="right">{format(Date.parse(invoice.docdate), "MM/dd/yyyy")}</TableCell>
          <TableCell align="right">{invoice.pymtrmid}</TableCell>
          <TableCell align="right">{formatter.format(invoice.subtotal)}</TableCell>
          <TableCell align="right">{format(Date.parse(invoice.dueDate), "MM/dd/yyyy")}</TableCell>
          <TableCell align="right">{formatter.format(invoice.frtamnt)}</TableCell>
          <TableCell align="right">{formatter.format(invoice.taxamnt)}</TableCell>
          <TableCell align="right">{formatter.format(invoice.ortrxamt)}</TableCell>
          <TableCell align="right">{Date.parse(invoice.dueDate) < Date.now() && invoice.curtrxam > 0 ?
           (<div className = 'bold-red'>{formatter.format(invoice.curtrxam)}</div>) :
            (<div className = 'bold'>{formatter.format(invoice.curtrxam)}</div>)}</TableCell>
          <TableCell align="right" onClick={() => reOrderItems(invoice.docnumbr)} className="cursor-pointer">REORDER</TableCell>
          <TableCell align="right" className="cursor-pointer">{invoice.curtrxam > 0.01 ? (
            <div className="flex-row">
            <div className = 'flex-col'>
               <img
                src={SaveLogo}
                width='30'
                height='30'
                 onClick={() => getReport(invoice.docnumbr, "Invoice_Posted","PostedInvoice")}
               />
              </div>
              <div className = 'flex-col lg:ml-10'>
               <a href="https://primepowerserv.securepayments.cardpointe.com/pay?"
                 target="_blank"
                 rel="noreferrer noopener">
               <img
                 src={PayLogo}
                 width='30'
                 height='30'
               /></a>
               </div>
            </div>
            ) : (
                <div className = 'flex-row'>
                    <div className = 'flex-col'>
                    <img
                      src={SaveLogo}
                      width='30'
                      height='30'
                      onClick={() => getReport(invoice.docnumbr,"Invoice_Posted","PostedInvoice")}
                    />
                    </div>
                  </div>
            )}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1,  maxwidth: 380 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Details
                </Typography>
                <Table size="small" aria-label="purchases"  sx={{ border: 'none', boxShadow: 'none' , marginLeft: 10,}}>
                  <TableHead>
                  <TableRow >
                                {childColumn.map((column) => (
                                    <TableCell
                                       
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoice.details.map((detail) => (
                      <TableRow key={detail.sopnumbe}>
                        <TableCell component="th" scope="row">
                          {detail.sopnumbe}
                        </TableCell>
                        <TableCell align="right">{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</TableCell>
                        <TableCell align="right">{detail.itemnmbr}</TableCell>
                        <TableCell align="right">
                          {detail.itemdesc}
                        </TableCell>
                        <TableCell align="right">{detail.locncode}</TableCell>
                        <TableCell align="right">{formatter.format(detail.unitprce)}</TableCell>
                        <TableCell align="right">{detail.quantity}</TableCell>
                        <TableCell align="right">{formatter.format(detail.xtndprce)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  function QuoteRow(props) {
    const { quote, childColumn, reOrderItems, getReport } = props;
    const [open, setOpen, ] = React.useState(false);
  
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowDownIcon /> : <AddIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
                 {quote.sopnumbe}
          </TableCell>
          <TableCell align="right">{format(Date.parse(quote.quotedat), "MM/dd/yyyy")}</TableCell>
          <TableCell align="right">{formatter.format(quote.docamnt)}</TableCell>
          <TableCell align="right">{quote.custname}</TableCell>
          <TableCell align="right" onClick={() => reOrderItems(quote.sopnumbe)} className="cursor-pointer">REORDER</TableCell>
          <TableCell align="right"><img src={SaveLogo} width='30' height='30' className="ml-10 cursor-pointer"
                     onClick={() => getReport(quote.sopnumbe, "Quote" ,"Quote")}/>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Details
                </Typography>
                <Table size="small" aria-label="purchases"  sx={{ border: 'none', boxShadow: 'none' , marginLeft: 10}}>
                  <TableHead>
                  <TableRow >
                                {childColumn.map((column) => (
                                    <TableCell
                                       
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                  </TableHead>
                  <TableBody>
                    {quote.details.map((detail) => (
                      <TableRow key={detail.sopnumbe}>
                        <TableCell component="th" scope="row">
                          {detail.sopnumbe}
                        </TableCell>
                        <TableCell align="right">{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</TableCell>
                        <TableCell align="right">{detail.itemnmbr}</TableCell>
                        <TableCell align="right">
                          {detail.itemdesc}
                        </TableCell>
                        <TableCell align="right">{detail.locncode}</TableCell>
                        <TableCell align="right">{formatter.format(detail.unitprce)}</TableCell>
                        <TableCell align="right">{detail.quantity}</TableCell>
                        <TableCell align="right">{formatter.format(detail.xtndprce)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

// class Portal extends React.Component {
    // constructor() {
    //     super();
    //     this.state = {
    //         name: 'React',
    //         apiquote: [],
    //         currentInvoicePage: 1,
    //         currentInvoiceData: [],
    //         invoiceList: [],
    //         currentOrderPage: 1,
    //         currentOrderData: [],
    //         orderList: [],
    //         isOpen: false,
    //         pdfView: null,
    //         viewDashboard: true,
    //         viewInvoices: false,
    //         viewOrders: false,
    //         balance: 0,
    //         pastdue: 0,
    //         lastInvoice: null,
    //         lastInvoiceItems: [],
    //         purchasedItems: [],
    //         lastOrderInclude: "invoice",
    //         purchasedInclude: "invoice",
    //         invoiceSortField: null,
    //         sortDirection: null,
    //         activeItem: null,
    //         isModalOpen: false,
    //         selectedOrder: []
    //     };
    // }

    // showDashboard() {
    //     this.setState({ viewDashboard: true });
    //     this.setState({ viewInvoices: false });
    //     this.setState({ viewOrders: false });
    // }

    // showInvoices() {
    //     this.setState({ viewInvoices: true });
    //     this.setState({ viewOrders: false });
    //     this.setState({ viewDashboard: false });
    // }

    // showOrders() {
    //     this.setState({ viewInvoices: false });
    //     this.setState({ viewOrders: true });
    //     this.setState({ viewDashboard: false });
    // }

    // async componentDidMount() {        
    //     console.log('app mounted');

    //     const tokenString = sessionStorage.getItem("token");
    //     const token = JSON.parse(tokenString);

    //     let headers = new Headers({
    //         "Accept": "application/json",
    //         "Content-Type": "application/json",
    //         'Authorization': 'Bearer ' + token.token
    //     });

        // const response = await fetch(apiUrl + `/api/Orders/GetAllInvoices`, {
        //    method: "GET",
        //    headers: headers
        // });
        // const json = await response.json();
        // console.log(json);
        // this.setState({ invoiceList: json });

        // const response2 = await fetch(apiUrl + `/api/Orders/GetAllOrders`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json2 = await response2.json();
        // console.log(json2);
        // this.setState({ orderList: json2 });

        // const response3 = await fetch(apiUrl + `/api/Orders/GetBalance`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json3 = await response3.json();
        // console.log(`Balance ${json3}`);
        // this.setState({ balance: json3 });

        // const response4 = await fetch(apiUrl + `/api/Orders/GetLastInvoice?include=${this.state.lastOrderInclude}`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json4 = await response4.json();
        // console.log(`Balance ${json4}`);
        // this.setState({ lastInvoice: json4 });

        // const response5 = await fetch(apiUrl + `/api/Orders/GetLastInvoiceItems?include=${this.state.lastOrderInclude}`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json5 = await response5.json();
        // console.log(`Balance ${json5}`);
        // this.setState({ lastInvoiceItems: json5 });

        // const response6 = await fetch(apiUrl + `/api/Orders/GetPurchasedItems?include=${this.state.purchasedInclude}`, {
        //     method: "GET",
        //     headers: headers
        // });
        // const json6 = await response6.json();
        // console.log(`Balance ${json6}`);
        // this.setState({ purchasedItems: json6 });

    //     const response7 = await fetch(apiUrl + `/api/Orders/GetPastDue`, {
    //         method: "GET",
    //         headers: headers
    //     });
    //     const json7 = await response7.json();
    //     this.setState({ pastdue: json7 });
    // }

    // async componentDidUpdate(_, prevState) {
    //     console.log('Component Updated');
    //     if (prevState.currentInvoicePage !== this.state.currentInvoicePage || prevState.invoiceList !== this.state.invoiceList) {
    //         const firstPageIndex = (this.state.currentInvoicePage - 1) * PageSize;
    //         const lastPageIndex = firstPageIndex + PageSize;
    //         this.setState({ currentInvoiceData: this.state.invoiceList.slice(firstPageIndex, lastPageIndex) });
    //     }

    //     if (prevState.currentOrderPage !== this.state.currentOrderPage || prevState.orderList !== this.state.orderList) {
    //         const firstPageIndex = (this.state.currentOrderPage - 1) * PageSize;
    //         const lastPageIndex = firstPageIndex + PageSize;
    //         this.setState({ currentOrderData: this.state.orderList.slice(firstPageIndex, lastPageIndex) });
    //     }

    //     if (prevState.lastOrderInclude !== this.state.lastOrderInclude) {
    //         const tokenString = sessionStorage.getItem("token");
    //         const token = JSON.parse(tokenString);

    //         let headers = new Headers({
    //             "Accept": "application/json",
    //             "Content-Type": "application/json",
    //             'Authorization': 'Bearer ' + token.token
    //         });

    //         const response4 = await fetch(apiUrl + `/api/Orders/GetLastInvoice?include=${this.state.lastOrderInclude}`, {
    //             method: "GET",
    //             headers: headers
    //         });
    //         const json4 = await response4.json();
    //         console.log(`Balance ${json4}`);
    //         this.setState({ lastInvoice: json4 });

    //         const response5 = await fetch(apiUrl + `/api/Orders/GetLastInvoiceItems?include=${this.state.lastOrderInclude}`, {
    //             method: "GET",
    //             headers: headers
    //         });
    //         const json5 = await response5.json();
    //         console.log(`Balance ${json5}`);
    //         this.setState({ lastInvoiceItems: json5 });
    //     }

    //     if (prevState.purchasedInclude !== this.state.purchasedInclude) {
    //         const tokenString = sessionStorage.getItem("token");
    //         const token = JSON.parse(tokenString);

    //         let headers = new Headers({
    //             "Accept": "application/json",
    //             "Content-Type": "application/json",
    //             'Authorization': 'Bearer ' + token.token
    //         });

    //         const response6 = await fetch(apiUrl + `/api/Orders/GetPurchasedItems?include=${this.state.purchasedInclude}`, {
    //             method: "GET",
    //             headers: headers
    //         });
    //         const json6 = await response6.json();
    //         console.log(`Balance ${json6}`);
    //         this.setState({ purchasedItems: json6 });
    //     }
    // }

    // See my questions: 
    // https://stackoverflow.com/questions/68697187/why-is-my-json-date-string-invalid-for-date-fns
    // https://stackoverflow.com/questions/68703201/what-do-i-need-to-do-to-access-currentpage-and-setcurrentpage-inside-my-rend
    // and this web article:
    // https://www.freecodecamp.org/news/build-a-custom-pagination-component-in-react/
    // render() {
        // const invoices = this.state.invoiceList;
        // const orders = this.state.orderList;
        // const currentInvoiceData = this.state.currentInvoiceData;
        // const currentOrderData = this.state.currentOrderData;
        // const { isOpen } = this.state;
        // const { isModalOpen } = this.state;
        // const { activeItem } = this.state;
        
        // const tokenString = sessionStorage.getItem("token");
        // const token = JSON.parse(tokenString);

        // const options = {
        //     labels: {
        //         confirmable: "OK",
        //         cancellable: ""
        //     }
        // }

        // let onRequestClose = () => {
        //     this.setState({ isOpen: false });
        // }

        // let onRequestModalClose = () => {
        //     this.setState({ isModalOpen: false });
        //     this.props.setCart(GetCart);
        // }

        // function handleClick(order) {
        //     console.log(JSON.stringify(order));
        //     this.setState({ selectedOrder: order });
        //     this.setState({ isOpen: true });
        // }      

        // handleClick = handleClick.bind(this)

        // function reorderClick(e, invoice) {
        //     /*e.preventDefault();*/
        //     let noninventory = "";
        //     let count = 0;
        //     if (!!invoice) {
        //         invoice.details.forEach(detail => {
        //             if (detail.noninven === 0) {
        //                 AddToCart(detail.itemnmbr, detail.unitprce, detail.quantity);
        //                 count = count + 1;
        //             } else {
        //                 if (noninventory !== "") {
        //                     noninventory = noninventory + `, ${detail.itemnmbr}`;
        //                 } else {
        //                     noninventory = detail.itemnmbr;
        //                 }
        //             }                    
        //         });

        //         if (noninventory !== "") {
        //             confirm(`Non-Inventory item(s) ${noninventory} were not added to the cart.`, options);
        //         }

            
        //         this.props.setCart(GetCart);
        //         if (count > 0) {
        //             confirm(`${count} item(s) have been added to your cart.`, options);
        //         }                
        //     }            
        // }

        // function reorderItemClick(item) {   
        //     this.setState({ activeItem: item });
        //     this.setState({ isModalOpen: true });
        //     //AddToCart(item.itemnmbr, item.unitprce, 1);
        //     //this.props.setCart(GetCart);
        // }

        // reorderItemClick = reorderItemClick.bind(this);

        // function setLastOrderInclude(e) {
        //     console.log(e.target.value)
        //     this.setState({ lastOrderInclude: e.target.value });
        // }

        // function setPurchasedInclude(e) {
        //     console.log(e.target.value)
        //     this.setState({ purchasedInclude: e.target.value });
        // }

        // function setInvoiceSortField(field) {            
        //     let sortedInvoices = [...this.state.invoiceList];

        //     if (this.state.sortDirection === null) {
        //         this.setState({ sortDirection: "ascending" })
        //     }
        //     else if (this.state.sortDirection === "ascending") {
        //         this.setState({ sortDirection: "descending" })
        //     }
        //     else {
        //         this.setState({ sortDirection: "ascending" })
        //     }

        //     if (field !== null) {
        //         sortedInvoices.sort((a, b) => {                    
        //             if (a[field] < b[field]) {
        //                 return this.state.sortDirection === "ascending" ? -1 : 1;
        //             }
        //             if (a[field] > b[field]) {
        //                 return this.state.sortDirection === "ascending" ? 1 : -1;
        //             }
        //             return 0;
        //         });
                
        //         this.setState({ invoiceList: sortedInvoices });
        //     }
        // }

        // setInvoiceSortField = setInvoiceSortField.bind(this);

        // const pickingStyle = () => ({
        //     fontWeight: "bold"
        // });

        // const backorderedStyle = () => ({
        //     fontWeight: "bold",
        //     color: "red"
        // });

        // const shippedStyle = () => ({
        //     fontWeight: "bold",
        //     color: "green"
        // });

        // function setStatusFont(field) {
        //     if (field === "Picking ") {
        //         return (<td style={pickingStyle()}>{field}</td>);
        //     }
        //     else if (field === "Backordered") {
        //         return (<td style={backorderedStyle()}>{field}</td>);
        //     }
        //     else if (field == "Shipped") {
        //         return (<td style={shippedStyle()}>{field}</td>);
        //     }
        //     else {
        //         return (<td>{field}</td>);
        //     }
        // }

        // function setOrderSortField(field) {
        //     let sortedOrders = [...this.state.orderList];

        //     if (this.state.sortDirection === null) {
        //         this.setState({ sortDirection: "ascending" })
        //     }
        //     else if (this.state.sortDirection === "ascending") {
        //         this.setState({ sortDirection: "descending" })
        //     }
        //     else {
        //         this.setState({ sortDirection: "ascending" })
        //     }

        //     if (field !== null) {
        //         sortedOrders.sort((a, b) => {
        //             if (a[field] < b[field]) {
        //                 return this.state.sortDirection === "ascending" ? -1 : 1;
        //             }
        //             if (a[field] > b[field]) {
        //                 return this.state.sortDirection === "ascending" ? 1 : -1;
        //             }
        //             return 0;
        //         });

        //         this.setState({ orderList: sortedOrders });
        //     }
        // }

        // setOrderSortField = setOrderSortField.bind(this);

        // reorderClick = reorderClick.bind(this);

        // function handleInvoiceClick(e, invoice) {            
        //     e.preventDefault();
        //     console.log(`invoice: ${JSON.stringify(invoice)}`)
        //     if (this.state.pdfView === null) {
        //         const headerString = sessionStorage.getItem("header");
        //         const header = JSON.parse(headerString);
        //         const buff = new Buffer(header.logoImage, 'base64');                
        //         //let pdf = (       
        //         //    <PDFViewer width="1000" height="600" className="portal">                            
        //         //        <Invoice invoice={invoice} buff={buff} />                            
        //         //    </PDFViewer>
        //         //);
        //         //this.setState({ pdfView: pdf });
        //     } else {
        //         //this.setState({ pdfView: null });
        //     }
        // }

        // handleInvoiceClick = handleInvoiceClick.bind(this);

//         return (
//             <div id="bootstrap-overrides">
//                 <h2>{token.customerName} - My Account</h2>
//                 <div className="row">
//                     <div className="block col-1" style={{ marginLeft: "10px" }}>
//                         <h5><FontAwesomeIcon icon={faUser} className="fa-fw" />My Account</h5>
//                         <hr />
//                         <p><div role="menuitem" onClick={this.showDashboard.bind(this)}>Dashboard</div></p>
//                         <p><div role="menuitem" onClick={this.showInvoices.bind(this)}>Invoices</div></p>
//                         <p><div role="menuitem" onClick={this.showOrders.bind(this)}>Orders</div></p>
//                         <p><a>Payment Methods</a></p>
//                         <p><a>Lists</a></p>
//                         <br />
//                         <h5><FontAwesomeIcon icon={faGift} className="fa-fw" />Rewards</h5>
//                         <hr />
//                         <p><a>Overview</a></p>
//                         <p><a>Super Rewards</a></p>
//                         <br />
//                         <h5><FontAwesomeIcon icon={faStar} className="fa-fw" />My Activity</h5>
//                         <hr />
//                         <p><a>My Page</a></p>
//                         <br />
//                         <h5><FontAwesomeIcon icon={faCog} className="fa-fw" />Settings</h5>
//                         <hr />
//                         <p><a>Account Information</a></p>
//                         <p><a>Communication Preferences</a></p>
//                     </div>
//                     <div className="block col-2 g-0">
//                         <br />
//                         {this.state.pdfView}
//                         <Collapse isOpen={this.state.viewInvoices}>
//                             <div id="myOrder">
//                             <h3>Open Invoices</h3>
//                             <h4>A list of completed orders purchased under this account.</h4>
//                             <table className="table table-striped table-bordered">
//                                 <thead>
//                                     <tr>
//                                         <th className="number"><div role="button" onClick={() => setInvoiceSortField('sopnumbe') }>Invoice Number</div></th>
//                                         <th className="date"><div role="button" onClick={() => setInvoiceSortField('invodate')}>Invoice Date</div></th>
//                                         <th className="origin"><div role="button" onClick={() => setInvoiceSortField('origin')}>Doc Source</div></th>
//                                         <th className="date"><div role="button" onClick={() => setInvoiceSortField('duedate')}>Due Date</div></th>
//                                         <th className="amount"><div role="button" onClick={() => setInvoiceSortField('docamnt')}>Total</div></th>
//                                         <th className="customer"><div role="button" onClick={() => setInvoiceSortField('custname')}>Ship To</div></th>
//                                         <th className="date"><div role="button" onClick={() => setInvoiceSortField('actlship')}>Actual Ship Date</div></th>
//                                         <th className="button"></th>
//                                         <th className="button"></th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentInvoiceData && currentInvoiceData.map(order =>
//                                         <>
//                                             <tr key={order.sopnumbe}>
//                                                 <td><div role="link" className="clickable" onClick={(e) => handleInvoiceClick(e, order)}>{order.sopnumbe}</div></td>
//                                                 <td>{format(Date.parse(order.invodate), 'MM/dd/yyyy')}</td>
//                                                 <td>{order.origin === "OE" ? "Order Entry" : order.origin }</td>
//                                                 <td>{format(Date.parse(order.duedate), 'MM/dd/yyyy')}</td>
//                                                 <td>{formatter.format(order.docamnt)}</td>
//                                                 <td>{order.custname}</td>
//                                                 <td>{format(Date.parse(order.actlship), 'MM/dd/yyyy')}</td>
//                                                 <td>{order.pymtrcvd >= order.docamnt ? "Paid" : <Button className="BtnPay" onClick={() => handleClick(order)}>Pay</Button>}</td>
//                                                 <td><Button className="BtnReorder" onClick={(e) => reorderClick(e, order)}>Reorder</Button></td>
//                                             </tr>                                                                          
//                                         </>
//                                     )}
//                                 </tbody>
//                             </table>                
//                             <Pagination
//                                 className="pagination-bar"
//                                 currentPage={this.state.currentInvoicePage}
//                                 totalCount={invoices.length}
//                                 pageSize={PageSize}
//                                 onPageChange={page => this.setState({ currentInvoicePage: page })}
//                                 />
//                                 {isOpen ? <PaymentModal invoice={this.state.selectedOrder} onRequestClose={onRequestClose} /> : null}
//                                 </div>
//                         </Collapse>
//                         <Collapse isOpen={this.state.viewOrders}>
//                             <div id="myOrder">
//                             <h3>Open Orders</h3>
//                             <h4>A list of completed orders purchased under this account.</h4>
//                             <table className="table table-striped table-bordered">
//                                 <thead>
//                                     <tr>
//                                             <th className="number"><div role="button" onClick={() => setOrderSortField('sopnumbe')}>Order Number</div></th>
//                                         <th className="date"><div role="button" onClick={() => setOrderSortField('ordrdate')}>Order Date</div></th>
//                                         <th className="origin"><div role="button" onClick={() => setInvoiceSortField('origin')}>Doc Source</div></th>
//                                         <th className="date"><div role="button" onClick={() => setOrderSortField('duedate')}>Due Date</div></th>
//                                         <th className="amount"><div role="button" onClick={() => setOrderSortField('docamnt')}>Total</div></th>
//                                         <th className="customer"><div role="button" onClick={() => setOrderSortField('custname')}>Ship To</div></th>
//                                         <th className="date"><div role="button" onClick={() => setOrderSortField('status')}>Status</div></th>
//                                         <th className="button"></th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {currentOrderData && currentOrderData.map(order =>
//                                         <>
//                                             <tr key={order.sopnumbe}>
//                                                 <td><a href="#" onClick={(e) => handleInvoiceClick(e, order)}>{order.sopnumbe}</a></td>
//                                                 <td>{format(Date.parse(order.ordrdate), 'MM/dd/yyyy')}</td>
//                                                 <td>{order.origin === "OE" ? "Order Entry" : order.origin}</td>
//                                                 <td>{format(Date.parse(order.duedate), 'MM/dd/yyyy')}</td>
//                                                 <td>{formatter.format(order.docamnt)}</td>
//                                                 <td>{order.custname}</td>
//                                                 {setStatusFont(order.status)}
//                                                 <td>{order.pymtrcvd >= order.docamnt ? "Paid" : <Button className="BtnPay" onClick={() => handleClick(order)}>Pay</Button>}</td>
//                                             </tr>                                            
//                                         </>
//                                     )}
//                                 </tbody>
//                             </table>
//                             <Pagination
//                                 className="pagination-bar"
//                                 currentPage={this.state.currentOrderPage}
//                                 totalCount={orders.length}
//                                 pageSize={PageSize}
//                                 onPageChange={page => this.setState({ currentOrderPage: page })}
//                                 />
//                                 {isOpen ? <PaymentModal invoice={this.state.selectedOrder} onRequestClose={onRequestClose} /> : null}
//                                 </div>
//                         </Collapse>
//                         <Collapse isOpen={this.state.viewDashboard}>
//                             <h3>Dashboard</h3>
//                             <div id="myOrder" className="dashboard">
//                                 <div className="row dashboard-header">
//                                     <div className="balance">
//                                         <div className="row">
//                                             <span>
//                                             <h6>Your Balance</h6>
//                                                 <div className="amount-owed">{formatter.format(this.state.balance)}</div>
//                                                 </span>
//                                         </div>
//                                         <div className="row">
//                                         <span>
//                                                 <h6>Past Due</h6>
//                                                 <div className="amount-owed" style={{ color: "red" }}>{formatter.format(this.state.pastdue)}</div>
//                                             </span>
//                                         </div>
//                                     </div>                                    
//                                 </div>
//                                 <div className="mydiv">
//                                     <div className="row divheader">
//                                         <label>Your Last Transaction</label>
//                                         <label>Trx Number: {!!this.state.lastInvoice ? this.state.lastInvoice.sopnumbe : "None"}</label>
//                                         <label>Trx Date: {!!this.state.lastInvoice ? format(Date.parse(this.state.lastInvoice.ordrdate), 'MMMM d yyyy') : "None"}</label>
//                                         <label>Total: {!!this.state.lastInvoice ? formatter.format(this.state.lastInvoice.docamnt) : "None"}</label>
//                                         <span>
//                                             <label>Include: </label>
//                                             <select id="lastorder" onChange={setLastOrderInclude.bind(this)} value={this.state.lastOrderInclude}>
//                                                 <option value="invoice">Invoices</option>
//                                                 <option value="order">Orders</option>
//                                                 <option value="both">Both</option>
//                                             </select>
//                                         </span>
//                                         <Button className="BtnReorder" onClick={(e) => reorderClick(e, this.state.lastInvoice)}>Reorder</Button>
//                                     </div>
//                                     <div className="row divbody">
//                                         <CardGroup id="container" className="card-group-scroll">
//                                             {this.state.lastInvoiceItems && this.state.lastInvoiceItems.map(item =>
//                                                 <>
//                                                     <Card key={item.itemNumber} tag="a" onClick={() => reorderItemClick(item)} style={{ cursor: "pointer" }}>
//                                                         <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
//                                                         <CardBody className="card-body">
//                                                             <CardTitle tag="h5">{item.itemNumber}</CardTitle>
//                                                             <CardSubtitle tag="h6" className="mb-2 text-muted">{item.categoryName}</CardSubtitle> 
//                                                         </CardBody>                                                        
//                                                     </Card>
//                                                 </>
//                                             )}
//                                         </CardGroup>
//                                     </div>
//                                 </div>
//                                 <div className="mydiv">
//                                     <div className="row divheader">
//                                         <label>Buy it again</label>
//                                         <label>Activity Last 90 Days</label>
//                                         <span>
//                                             <label>Include: </label>
//                                             <select id="purchaseItems" onChange={setPurchasedInclude.bind(this)} value={this.state.purchasedInclude}>
//                                                 <option value="invoice">Invoices</option>
//                                                 <option value="order">Orders</option>
//                                                 <option value="both">Both</option>
//                                             </select>
//                                         </span>
//                                     </div>
//                                     <div className="row divbody">
//                                         <CardGroup id="container" className="card-group-scroll">
//                                             {this.state.purchasedItems && this.state.purchasedItems.map(item =>
//                                                 <>
//                                                     <Card key={item.itemNumber} tag="a" onClick={() => reorderItemClick(item)} style={{ cursor: "pointer" }}>
//                                                         <CardImg top className="card-picture" src={"data:image/png;base64," + decompressToBase64(item.images[0]?.compressedImageData)} id={item.itemNumber + "Img"} alt={item.itemNumber} />
//                                                         <CardBody className="card-body">
//                                                             <CardTitle tag="h5">{item.itemNumber}</CardTitle>
//                                                             <CardSubtitle tag="h6" className="mb-2 text-muted">{item.categoryName}</CardSubtitle>
//                                                         </CardBody>
//                                                     </Card>
//                                                 </>
//                                             )}
//                                         </CardGroup>
//                                     </div>
//                                 </div>
//                             </div>
//                             {isModalOpen ? <ItemModal item={activeItem} onRequestClose={onRequestModalClose} /> : null}                            
//                         </Collapse>
//                     </div>
//                 </div>
//             </div>
//         );
//     }
// }
// export default Portal;                                <div><img src={image} alt="Profile Picture" /></div>
//                                     <div>
//                                         <h5>Welcome, {token.firstName}!</h5>
//                                         Customer since {format(Date.parse(token.customerSince),'MMMM d yyyy')}
//                                     </div>
//     
